import styled from 'styled-components';

export const HorizontalDashedConnector = styled.div`
  width: 100%;
  border-top: 1.5px
    ${(props) => {
      switch (props.color) {
        case 'warning':
          return '#F2994A';
        case 'success':
          return '#6FCF97';
        default:
          return '#C4C4C4';
      }
    }}
    solid;
  border-style: dashed;
`;

export const VerticalDashedConnector = styled.div`
  height: 100%;
  border-left: 1.5px #56ccf2 solid;
  border-style: dashed;
`;
